// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.form-input__colorpicker .clr-field button {\n    width: 32px;\n    height: 32px;\n    left: 6px;\n    right: auto;\n    border-radius: 4px;\n    z-index: 22;\n}\n.form-input__colorpicker .clr-field {\n    width: 100%;\n}\n.form-input__colorpicker .clr-field input {\n    padding-left: 48px;\n    position: relative;\n    min-height: 48px;\n    border: solid 1px var(--color-slate-two);\n    border-radius: 4px;\n    width: 100%;\n    box-sizing: border-box;\n}\n", ""]);
// Exports
module.exports = exports;
